import React from 'react';
import Image from 'next/image';
import { motion } from 'framer-motion';
import HazardIcon from '../../HazardIcon';
import { hazards } from '../../GamePlay/hazards';
import useIsMobile from '@/hooks/useIsMobile';

interface GuessingIndicatorProps {
    hasGuessed: boolean;
    isEliminated: boolean;
    hasHazardsActive: boolean;
    currentHazards: string[];
}

const GuessingIndicator: React.FC<GuessingIndicatorProps> = ({
    hasGuessed,
    isEliminated,
    hasHazardsActive,
    currentHazards,
}) => {
    const isMobile = useIsMobile();
    if (isEliminated) return null;

    return (
        <div className="absolute h-full -right-3 top-0 text-xl translate-x-full flex gap-2 items-center">
            {/* Hazards */}
            {hasHazardsActive && !isMobile && currentHazards.length > 0 && (
                <div className="flex gap-1">
                    {currentHazards.map((hazardName, index) => {
                        const hazard = hazards.find(h => h.name === hazardName.toLowerCase());
                        if (!hazard) return null;
                        return <HazardIcon key={`hazard-icon-${index}`} hazard={hazard} size={24} className="" />;
                    })}
                </div>
            )}
            {hasGuessed ? (
                <Image
                    src='/checkmark.png'
                    alt="Check Icon"
                    height={24}
                    width={24}
                />
            ) : (
                <div className="flex space-x-1">
                    {[0, 1, 2].map((i) => (
                        <motion.div
                            key={i}
                            className="w-2 h-2 bg-white/50 shadow shadow-black rounded-full"
                            animate={{
                                opacity: [0, 0, 0, 0, 1, 1, 1, 1, 0],
                            }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                delay: i * 0.5,
                                ease: "easeInOut",
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default GuessingIndicator;
